import { ProjectService } from '../../types/entities';

export const formatService = (
  serviceState: ProjectService,
): ProjectService => ({
  ...serviceState,
  // TODO: remove after BE changes
  host: serviceState.ipAddress || serviceState.host,
});
